export default "/assets/images/basic-breather-small.fcf3db750f700d8e.webp";